import { Box, Flex, Tag, TagLabel } from '@chakra-ui/react';
import { Row } from '@tanstack/react-table';
import {
  CategoryTag as Vertical,
  categoryOptions,
} from '~/components/CategoryTag/CategoryTag.model';
import { HighlightSearchTerm } from '~/components/HighlightSearchTerm';
import { useHover } from '~/screens/WhalarModeScreen/hooks/useHover';
import { ICreator } from '~/types';
import { convertPxToRems } from '~/utils-ts';

import { EmptyCell } from './Columns';
import { cellContainer } from './styles';

//TODO: This component should be refactored and use CategoryTag generic component
// that we have in src/components folder and we use in StackView.

interface Props {
  row: Row<ICreator>;
}

export const verticalOptions: Record<
  Vertical,
  { name: Vertical; color: string }
> = categoryOptions;
export const filterVerticals = (categoryAgency: string | undefined) => {
  if (categoryAgency) {
    const list = categoryAgency
      ? categoryAgency.split(',').map((v) => v.trim())
      : [];
    const filteredVerticals = Object.values(verticalOptions).filter((v) =>
      list.includes(v.name),
    );
    return filteredVerticals;
  }
  return [];
};

export const Verticals: React.FC<Props> = ({ row }) => {
  const [hoverElemRef] = useHover<HTMLDivElement>();
  const { categoryAgency } = row.original;
  const filteredVerticals = filterVerticals(categoryAgency);

  return (
    <Box ref={hoverElemRef} {...cellContainer} width="200px">
      {categoryAgency ? (
        <Flex justify="wrap" alignItems="center" gap={convertPxToRems(4)}>
          {filteredVerticals.map((v) => (
            <Tag
              key={v.name}
              size="md"
              borderRadius="full"
              variant="outline"
              color={v.color}
              colorScheme={v.color}
              border={`1px solid ${v.color}`}
            >
              <TagLabel>
                <HighlightSearchTerm>{v.name}</HighlightSearchTerm>
              </TagLabel>
            </Tag>
          ))}
        </Flex>
      ) : (
        <EmptyCell content="-" />
      )}
    </Box>
  );
};
